document.addEventListener("DOMContentLoaded", () => {

  const cartForm = document.querySelector('form[action="/cart"]');

  if (!cartForm) return;

  cartForm.addEventListener("submit", function (e) {

    const quantityInputs = cartForm.querySelectorAll('input[type="number"]');

    let hasError = false;

    quantityInputs.forEach((input) => {

      let value = parseInt(input.value);

      if (isNaN(value) || value < 1) {
        input.value = 1;
      }

      if (value > 99) {
        input.value = 99;
      }

    });

    if (hasError) {
      e.preventDefault();
    }

  });

});



// Limit compare products to 4

document.addEventListener("DOMContentLoaded", () => {

  const compareButtons = document.querySelectorAll('[data-compare-product]');

  compareButtons.forEach((button) => {

    button.addEventListener("click", function (e) {

      let comparedProducts = JSON.parse(localStorage.getItem('compare-products')) || [];

      const productId = this.dataset.productId;

      // If already added, allow removal
      if (comparedProducts.includes(productId)) {
        return;
      }

      // Limit reached
      if (comparedProducts.length >= 4) {

        e.preventDefault();

        alert('You can compare up to 4 products only.');

        this.checked = false;

        return false;
      }

    });

  });

});


  document.addEventListener('DOMContentLoaded', function () {

    const successMessage = document.querySelector('.form-status-success');

    if (!successMessage) return;

    if (window.location.hash === '#contact_form') {
      history.replaceState({}, document.title, window.location.pathname);
    }

    const navEntries = performance.getEntriesByType('navigation');

    if (navEntries.length && navEntries[0].type === 'reload') {
      successMessage.remove();
    }

  });


  /**
 * Shopify Flexi Contact Form Validation
 * Validation based on provided Excel test cases
 */

document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("#flexi-contact-form");

  if (!form) return;

  const fields = {
    name: form.querySelector('input[name="contact[name]"]'),
    phone: form.querySelector('input[name="contact[phone]"]'),
    email: form.querySelector('input[name="contact[email]"]'),
    subject: form.querySelector('input[name="contact[subject]"]'),
    message: form.querySelector('textarea[name="contact[message]"]'),
  };

  /**
   * =========================
   * Helper Functions
   * =========================
   */

  const trimValue = (value) => value.trim();

  const hasOnlySpaces = (value) => !value || value.trim() === "";

  const containsHTML = (value) => {
    return /<[^>]*>/g.test(value);
  };

  const containsSQLInjection = (value) => {
    return /(\b(SELECT|INSERT|DELETE|UPDATE|DROP|UNION|ALTER|CREATE)\b|--|'|"|;)/gi.test(
      value
    );
  };

  const containsScript = (value) => {
    return /(javascript:|<script|<iframe|onerror=|constructor\.constructor)/gi.test(
      value
    );
  };

  const isOnlySpecialChars = (value) => {
    return /^[^a-zA-Z0-9\u00C0-\u024F\u0900-\u097F]+$/u.test(value);
  };

  const showError = (field, message) => {
    removeError(field);

    field.classList.add("field-error");

    const error = document.createElement("p");
    error.className = "field-error-message";
    error.innerText = message;

    field.parentNode.appendChild(error);
  };

  const removeError = (field) => {
    field.classList.remove("field-error");

    const existingError =
      field.parentNode.querySelector(".field-error-message");

    if (existingError) {
      existingError.remove();
    }
  };

  /**
   * =========================
   * Name Validation
   * =========================
   */
  const validateName = () => {
    const field = fields.name;
    let value = trimValue(field.value);

    removeError(field);

    if (hasOnlySpaces(value)) {
      showError(field, "Name is required.");
      return false;
    }

    if (value.length < 2) {
      showError(field, "Name must be at least 2 characters.");
      return false;
    }

    if (value.length > 255) {
      showError(field, "Name is too long.");
      return false;
    }

    if (
      containsHTML(value) ||
      containsSQLInjection(value) ||
      containsScript(value)
    ) {
      showError(field, "Invalid characters in name.");
      return false;
    }

    // Allows Unicode, apostrophe, hyphen, spaces
    const regex = /^[\p{L}\s'-]+$/u;

    if (!regex.test(value)) {
      showError(field, "Numbers and special characters are not allowed.");
      return false;
    }

    field.value = value;
    return true;
  };

  /**
   * =========================
   * Phone Validation
   * =========================
   */
  const validatePhone = () => {
    const field = fields.phone;
    let value = trimValue(field.value);

    removeError(field);

    if (hasOnlySpaces(value)) {
      showError(field, "Phone number is required.");
      return false;
    }

    if (
      containsHTML(value) ||
      containsSQLInjection(value) ||
      containsScript(value)
    ) {
      showError(field, "Invalid phone number.");
      return false;
    }

    // Reject alphabets
    if (/[a-zA-Z]/.test(value)) {
      showError(field, "Phone number should not contain letters.");
      return false;
    }

    // Reject multiple +
    if ((value.match(/\+/g) || []).length > 1) {
      showError(field, "Invalid phone number format.");
      return false;
    }

    // Allow: +1 (555) 123-4567 / 722 852 8095 / 7228528095
    const cleanNumber = value.replace(/[^\d]/g, "");

    if (cleanNumber.length < 10 || cleanNumber.length > 15) {
      showError(field, "Phone number must be between 10 and 15 digits.");
      return false;
    }

    if (/^0+$/.test(cleanNumber)) {
      showError(field, "Invalid phone number.");
      return false;
    }

    field.value = value;
    return true;
  };

  /**
   * =========================
   * Email Validation
   * =========================
   */
  const validateEmail = () => {
    const field = fields.email;
    let value = trimValue(field.value);

    removeError(field);

    if (hasOnlySpaces(value)) {
      showError(field, "Email is required.");
      return false;
    }

    if (
      containsHTML(value) ||
      containsSQLInjection(value) ||
      containsScript(value)
    ) {
      showError(field, "Invalid email address.");
      return false;
    }

    if (value.length > 255) {
      showError(field, "Email is too long.");
      return false;
    }

    const emailRegex =
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{1,}$/;

    if (!emailRegex.test(value)) {
      showError(field, "Enter a valid email address.");
      return false;
    }

    field.value = value;
    return true;
  };

  /**
   * =========================
   * Subject Validation
   * =========================
   */
  const validateSubject = () => {
    const field = fields.subject;
    let value = trimValue(field.value);

    removeError(field);

    if (hasOnlySpaces(value)) {
      showError(field, "Subject is required.");
      return false;
    }

    if (value.length < 2) {
      showError(field, "Subject must be at least 2 characters.");
      return false;
    }

    if (value.length > 255) {
      showError(field, "Subject is too long.");
      return false;
    }

    if (
      containsHTML(value) ||
      containsSQLInjection(value) ||
      containsScript(value)
    ) {
      showError(field, "Invalid subject.");
      return false;
    }

    if (isOnlySpecialChars(value)) {
      showError(field, "Subject cannot contain only special characters.");
      return false;
    }

    field.value = value;
    return true;
  };

  /**
   * =========================
   * Message Validation
   * =========================
   */
  const validateMessage = () => {
    const field = fields.message;
    let value = trimValue(field.value);

    removeError(field);

    if (hasOnlySpaces(value)) {
      showError(field, "Message is required.");
      return false;
    }

    if (value.length < 2) {
      showError(field, "Message must be at least 2 characters.");
      return false;
    }

    if (value.length > 5000) {
      showError(field, "Message is too long.");
      return false;
    }

    if (
      containsHTML(value) ||
      containsSQLInjection(value) ||
      containsScript(value)
    ) {
      showError(field, "Invalid message.");
      return false;
    }

    if (isOnlySpecialChars(value)) {
      showError(field, "Message cannot contain only special characters.");
      return false;
    }

    field.value = value;
    return true;
  };

  /**
   * =========================
   * Real-time Validation
   * =========================
   */

  fields.name.addEventListener("blur", validateName);
  fields.phone.addEventListener("blur", validatePhone);
  fields.email.addEventListener("blur", validateEmail);
  fields.subject.addEventListener("blur", validateSubject);
  fields.message.addEventListener("blur", validateMessage);

  /**
   * =========================
   * Form Submit Validation
   * =========================
   */

  form.addEventListener("submit", (e) => {
    const isValid =
      validateName() &&
      validatePhone() &&
      validateEmail() &&
      validateSubject() &&
      validateMessage();

    if (!isValid) {
      e.preventDefault();
    }
  });
});
